import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../shared/services/auth.service';
import {CardsBasicComponent} from "../../../shared/components/cards/cards-basic/cards-basic.component";
import {Router} from '@angular/router';
import {MatButton} from "@angular/material/button";
import {FormsModule} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../shared/services/django-api.service";
import {LanguageService} from "../../../shared/services/language.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {SnackbarService} from "../../../shared/services/snackbar.service";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CardsBasicComponent, MatButton, FormsModule, MatFormField, MatInput, MatLabel, MatCheckbox, MatInput, MatRadioGroup, MatRadioButton],
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit, OnDestroy {
  productData!: any;
  currentLanguage!: string;
  availableLanguages: any;
  userInfo: any;
  userProfile: any;
  isLoading: boolean = true;

  // Neues Objekt zur Bearbeitung des Profils
  profile = { email: '', phone_number: '' };

  private subscriptions: Subscription = new Subscription();
  private langChangeSubscription: Subscription | null = null;

  constructor(
    private _apiService: DjangoApiService,
    private _snackbarService: SnackbarService,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    private authService: AuthService,
    private _router: Router,
    private _translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.createEmptyUserProfile();
    this.setupLanguageSubscription();
    this.loadProductData();
    this.availableLanguages = this._languageService.availableLanguages;
    this.authService.getUserInfo().subscribe({
      next: (res: any) => {
        this.userInfo = res;
        console.log(res);
        // Fülle die Formularfelder mit den erhaltenen Werten
        this.profile.email = res.email;
        this.profile.phone_number = res.phone_number;
        this.isLoading = false;
        console.log(res);
      },
      error: (error) => {
        console.error('There was an error fetching the user information', error);
        this.isLoading = false;
      }
    });
  }

  createEmptyUserProfile() {
    this.userProfile = {
      first_name: '',
      last_name: '',
      language: this.currentLanguage,                // Default-Sprache: English
      product_subscriptions: []      // Als Array, um mehrere IDs zu speichern
    };

    this.getUserProfile();
  }


  private getUserProfile(){
    this.subscriptions.add(
      this.authService.getUserProfile().subscribe({
        next: (data: any) => {
          this.userProfile = data;
          console.log('User profile', data);
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error fetching user profile', error);
          this.isLoading = false;
        }
      })
    );
  }


  saveProfile(): void {
    this.authService.updateUserProfile(this.userProfile).subscribe({
      next: (data: any) => {
        this.userProfile = data;
        this._snackbarService.show('Updated Successfully');
        console.log('Profile updated', data);
      },
      error: (error) => {
        console.error('Error updating profile', error);
      }
    });
  }


  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  private loadProductData(): void {
    this.subscriptions.add(
      this._apiService.fetchProductList().subscribe({
        next: (response: any) => {
          this.productData = response;
          console.log('Products', response);
        },
        error: (error: any) => {
          console.log('Error loading Data', error);
        }
      })
    );
  }

  onProductCheckboxChange(event: MatCheckboxChange, productId: number): void {
    if (event.checked) {
      // Produkt zur Liste hinzufügen, wenn noch nicht vorhanden
      if (!this.userProfile.product_subscriptions.includes(productId)) {
        this.userProfile.product_subscriptions.push(productId);
      }
    } else {
      // Produkt aus der Liste entfernen
      this.userProfile.product_subscriptions = this.userProfile.product_subscriptions.filter((id:any) => id !== productId);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  logout(): void {
    this.authService.clearTokens();
    const currentLang = this._translateService.currentLang || 'en';
    this._router.navigate([`/${currentLang}`]);
  }

}
